export default "__VITE_ASSET__7c567313__"